import { useTranslation } from 'react-i18next';
import { RhfImageField, type RhfImageFieldProps } from './shared/RhfImageField';

export type TaxImageFieldProps = Omit<RhfImageFieldProps, 'label'> & {
  label?: string;
};

/**
 * `TaxImageField` — RHF-bound document upload for
 * `Org.legal.taxImage` (scanned tax certificate — PDF or photo).
 */
export function TaxImageField(props: TaxImageFieldProps) {
  const { t } = useTranslation('m-organization');
  return (
    <RhfImageField
      {...props}
      label={props.label ?? t('form.tax_picture.title')}
      uploadLabel={props.uploadLabel ?? t('form.tax_picture.title')}
    />
  );
}
